import Score from './Score'
export default Score



/** WEBPACK FOOTER **
 ** ./src/Score/index.js
 **/